import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid, Link,
    Table, TableBody, TableCell,
    TableHead,
    TableRow, TableSortLabel
} from "@mui/material";
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {FormattedMessage, useIntl} from "react-intl";
import AreaSelectDialog from "./AreaSelectDialog";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {DictItemDto} from "../../../../../modules/dict/dto/DictItemDto";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {AreaDto} from "../../../../../modules/vms/dto/AreaDto";
import {RequestPlaceDto} from "../../../../../modules/vms/dto/RequestPlaceDto";
import {useConfirm} from "material-ui-confirm";
import FormFieldText from "../../../../../components/FormFieldText";
import SearchIconButton from "../../../../../components/buttons/SearchIconButton";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import {DictItemCode} from "../../../../../modules/vms/constants/DictItemCode";
import {VisitorAccessLogDto} from "../../../../../modules/vms/dto/VisitorAccessLogDto";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import CloseButton from "../../../../../components/buttons/CloseButton";

export type RegisterHostFormProps = {
    visitRequest: VisitRequestDto;
    inviteProperties: Array<DictItemDto>;

    purposeTypes: Array<DictItemDto>;
    onChange: (name: string, value: any) => void;
    onNext: () => void;
    onPrevious: () => void;
    onLoadRequestHost: (requestHost: VisitRequestDto) => void;
    employeeEntityTypes: Array<DictItemDto>;
};
const RegisterHostForm: React.FC<RegisterHostFormProps> = (props) => {
    const intl = useIntl();
    const confirm = useConfirm();
    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    // 场所选择的对话框
    const [areaSelectDialogOpen, setAreaSelectDialogOpen] = useState(false);
    const [hostEmailVisible, setHostEmailVisible] = useState(false);
    const [selectHostDialogOpen, setSelectHostDialogOpen] = useState(false);
    const [hostInfoList, setHostInfoList] = useState(new Array<VisitRequestDto>());

    // 选择的场所显示字符串
    const [selectedPlaceStr, setSelectedPlaceStr] = useState('');
    useEffect(() => {
        for (let item of props.inviteProperties) {
            switch (item.code) {
                case DictItemCode.VMS_INVITE_PROPERTIES_HOST_EMAIL_FIELD_VISIBLE:
                    if (item.value === '1') {
                        setHostEmailVisible(true);
                    } else {
                        setHostEmailVisible(false);
                    }
                    break;

            }
        }
    }, [props.inviteProperties]);
    const fetchLastHostInfo = async (hostStaffNumber: string, hostEmail: string) => {
        if (hostStaffNumber || hostEmail) {
            const responseResult = await VisitRequestApi.getLastHostInfo(hostStaffNumber, hostEmail);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                if (responseResult.data) {
                    MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_SUCCESS'}));
                    props.onLoadRequestHost(responseResult.data);
                }
            }
        }
    };
    const fetchHostInfoList = async (hostFullName: string) => {
        if (hostFullName) {
            const responseResult = await VisitRequestApi.getHostInfoList(hostFullName);
            if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
                if (responseResult.data) {
                    let list = responseResult.data;
                    if(list!=null&&list.length>0){
                        if(list.length===1){
                            MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_SUCCESS'}));
                            props.onLoadRequestHost(list[0]);
                        }else{
                            setSelectHostDialogOpen(true)
                            setHostInfoList(list);
                        }
                    }

                }
            }
        }
    };
    const handleNext = () => {
        if (validate()) {
            props.onNext();
        }
    }
    const handlePrevious = () => {
        props.onPrevious();
    }
    const handleChange = (name: string, value: any) => {
        props.onChange(name, value);
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        // if (props.visitRequest.hostLastName === '') {
        //     newMessageMap.set('hostLastName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME_REQUIRED'}));
        // }
        // if (props.visitRequest.hostFirstName === '') {
        //     newMessageMap.set('hostFirstName', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_FIRST_NAME_REQUIRED'}));
        // }
        // if (props.visitRequest.hostMobile === '') {
        //     newMessageMap.set('hostMobile', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_MOBILE_REQUIRED'}));
        // } else if (!ValidateUtils.isMobileNumber(props.visitRequest.hostMobile)) {
        //     newMessageMap.set('hostMobile', intl.formatMessage({id: 'COMMON_MOBILE_FORMAT'}));
        // }
        //
        // if (props.visitRequest.hostEmail === '') {
        //     newMessageMap.set('hostEmail', intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_EMAIL_REQUIRED'}));
        // } else if (!ValidateUtils.isEmail(props.visitRequest.hostEmail)) {
        //     newMessageMap.set('hostEmail', intl.formatMessage({id: 'COMMON_EMAIL_FORMAT'}));
        // }

        // if (props.visitRequest.places.length <= 0) {
        //     newMessageMap.set('places', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACES_REQUIRED'}));
        // }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const handleSelectAreas = (areas: Array<AreaDto>) => {
        const places = new Array<RequestPlaceDto>();
        for (let area of areas) {
            const place = new RequestPlaceDto(area);
            places.push(place);
        }
        handleChange("places", places);
        const selectedPlaceStr = areas.map((area) => {
            return area.name
        }).join(',')

        setSelectedPlaceStr(selectedPlaceStr);
        setAreaSelectDialogOpen(false);
    }
    const handleSelectHost = (host: VisitRequestDto) => {
        setSelectHostDialogOpen(false)
        props.onLoadRequestHost(host);
    }

    return (
        <div>
            <AreaSelectDialog open={areaSelectDialogOpen} onCancel={() => setAreaSelectDialogOpen(false)}
                              onOk={handleSelectAreas}/>
            <Alert severity={"warning"}>
                <FormattedMessage id={'VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO_ALERT'}/>
            </Alert>
            <Dialog open={selectHostDialogOpen} fullWidth={true}>
                <DialogTitle>
                    <FormattedMessage id={'VMS_VISIT_REQUEST_HOST_SELECT'}/>
                </DialogTitle>
                <DialogContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow >

                                <TableCell>{intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_NAME'})}</TableCell>
                                <TableCell>{intl.formatMessage({id: 'VMS_VISIT_REQUEST_HOST_STAFF_NUMBER'})}</TableCell>
                                <TableCell>{intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_EMAIL"})}</TableCell>
                                <TableCell>{intl.formatMessage({id: "VMS_VISIT_REQUEST_EMPLOYEE_ENTITY"})}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {hostInfoList.map((row, index) => {
                                   return (
                                        <TableRow key={row.id} onClick={()=>handleSelectHost(row)}>
                                            <TableCell>{row.hostLastName}</TableCell>
                                            <TableCell>{row.hostStaffNumber}</TableCell>
                                            <TableCell>{row.hostEmail}</TableCell>
                                            <TableCell>{row.hostDepartmentName}</TableCell>
                                        </TableRow>
                                    )
                                }
                            )}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <CloseButton onClick={()=>setSelectHostDialogOpen(false)}/>
                </DialogActions>
            </Dialog>
            <Grid container spacing={2} style={{height: '60vh'}}>

                <Grid item xs={6}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                                   placeholder={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_FIRST_NAME_REQUIRED"})}
                                   value={props.visitRequest.hostLastName}
                                   errorText={messageMap.get("hostLastName")}
                                   onChange={(value) => {
                                       handleChange("hostLastName", value)
                                   }}
                                   onKeyDown={(key) => {
                                       if (key === 'Enter') {
                                           fetchHostInfoList(props.visitRequest.hostLastName);
                                       }
                                   }}
                                   endAdornment={<SearchIconButton
                                       onClick={() =>   fetchHostInfoList(props.visitRequest.hostLastName)}/>}
                    />
                </Grid>

                <Grid item xs={6}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_STAFF_NUMBER"})}
                                   placeholder={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_STAFF_NUMBER_REQUIRED"})}
                                   value={props.visitRequest.hostStaffNumber}
                                   errorText={messageMap.get("hostStaffNumber")}
                                   onChange={(value) => {
                                       handleChange("hostStaffNumber", value)
                                   }}
                                   endAdornment={<SearchIconButton
                                       onClick={() => fetchLastHostInfo(props.visitRequest.hostStaffNumber, '')}/>}/>
                </Grid>
                <Grid item xs={6}>

                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME"})}
                                   placeholder={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME_REQUIRED"})}
                                   value={props.visitRequest.hostDepartmentName}
                                   errorText={messageMap.get("hostDepartmentName")}
                                   onChange={(value) => {
                                       handleChange("hostDepartmentName", value)
                                   }}
                                  />

                </Grid>

                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE_TYPE"})}*/}
                {/*                     required={true} errorText={messageMap.get("purposeType")}*/}
                {/*                     value={props.visitRequest.purposeType}*/}
                {/*                     onChange={(value) => {*/}
                {/*                         handleChange("purposeType", value)*/}
                {/*                     }}*/}
                {/*                     items={props.purposeTypes.map((item) => {*/}
                {/*                         return {label: item.name, value: item.value}*/}
                {/*                     })}/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PURPOSE"})}*/}
                {/*                   value={props.visitRequest.purpose}*/}
                {/*                   onChange={(value) => {*/}
                {/*                       handleChange("purpose", value)*/}
                {/*                   }}/>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldDate label={intl.formatMessage({id: "VMS_VISIT_REQUEST_ARRIVE_DATE"})}*/}
                {/*                   required={true} errorText={messageMap.get("arriveStartDate")}*/}
                {/*                   value={dayjs(props.visitRequest.arriveStartDate, Formats.DATE_SIMPLE)}*/}
                {/*                   minDate={dayjs()}*/}
                {/*                   maxDate={dayjs().add(15, "days")}*/}
                {/*                   onChange={(value) => handleChange("arriveStartDate", value)}/>*/}
                {/*</Grid>*/}

                {/*<Grid item xs={6}>*/}
                {/*    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_PLACE"})}*/}
                {/*                   disabled={true}*/}
                {/*                   required={true} errorText={messageMap.get("places")}*/}
                {/*                   value={selectedPlaceStr}*/}
                {/*                   endAdornment={*/}
                {/*                       <Badge badgeContent={props.visitRequest.places.length} color="secondary"*/}
                {/*                              overlap="rectangular">*/}
                {/*                           <Button color="primary"*/}
                {/*                                   onClick={() => setAreaSelectDialogOpen(true)}>*/}
                {/*                               <FormattedMessage id="VMS_VISIT_REQUEST_PLACE_SELECT"/>*/}
                {/*                           </Button>*/}
                {/*                       </Badge>}/>*/}
                {/*</Grid>*/}
            </Grid>
            <Grid>
                <PreviousNextButton onPrevious={handlePrevious} onNext={() => handleNext()}/>
            </Grid>
        </div>
    );
};

export default RegisterHostForm;
